import { PlusIcon } from "@xola/icons";
import { Breadcrumb, Button, HeaderToolbar } from "@xola/ui-kit";
import { orderBy } from "lodash";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Merchandise } from "types";
import { Page } from "../Page";
import { ColumnLayout } from "@/components/Layout/ColumnLayout";
import { MerchandiseList } from "@/components/Product/MerchandiseList";
import { ProductSearch } from "@/components/Product/ProductSearch";
import { useAutoFetchCollection } from "@/hooks/useAutoFetchCollection";
import { useSearch } from "@/hooks/useSearch";
import { MERCHANDISE_API_PATH } from "@/models/Merchandise";

export const MerchandiseListPage = () => {
    const [search, setSearch] = useState("");
    const { data: merchandises, isLoading } = useAutoFetchCollection<Merchandise>(MERCHANDISE_API_PATH);
    const filtered = orderBy(
        useSearch(merchandises, (merchandise) => [merchandise.name, merchandise.id], search),
        (merchandise) => merchandise.name,
        ["asc"],
    );
    const isFiltered = search.length > 0;
    const history = useHistory();

    const handleCreateProductClick = () => {
        history.push("/products/merchandise/new");
    };

    return (
        <Page title="Merchandise">
            <ColumnLayout>
                <HeaderToolbar className="justify-between">
                    <HeaderToolbar.Breadcrumb>
                        <Breadcrumb.Item>Products</Breadcrumb.Item>
                        <Breadcrumb.Item>Merchandise</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>

                    <ProductSearch onSearch={setSearch} />

                    <Button className="flex-shrink-0" icon={<PlusIcon />} onClick={handleCreateProductClick}>
                        Create Merchandise
                    </Button>
                </HeaderToolbar>
                <ColumnLayout.Fill>
                    <MerchandiseList merchandises={filtered} isLoading={isLoading} isFiltered={isFiltered} />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
